import { Translatable } from "@icc/shared/helpers";

export class Guide {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    type: 'blind_guidance';
    width: number;
    img: null | string;
    /** Prowadnica zwykła */
    normalGuide: null | boolean;
    /** Prowadnica podwójna */
    doubleGuide: null | boolean;
    /** Prowadnica z odsadzeniem */
    insetGuide: null | boolean;
    /** Prowadnica "Nakładka" */
    overlayGuide: null | boolean;
    subguide: null | boolean;
    subguideMountedOverTopRail: null | boolean;
    spaceLamellaMm: number;
    spaceEndRailMm: number;
    onEdge: boolean;
    between: boolean;
    defaultGuideHandleId: number | null;
    order?: number;
    shutterTypes: number[];
    /** Wkład prowadnicy */
    child: null | Guide;
    default?: boolean;
    cordSupply?: null;
    length?: number | null;
    /** Długość technologiczna prowadnicy */
    technicalLength?: number | null;
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    cornerBox?: boolean;
    spaceLamellaAxisMm?: number;
    noCalculationCorrectionInnerGuide?: boolean;
    guideBoxInsertionMm?: number;
}

export interface IccGuide {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    type: 'blind_guidance';
    width: number;
    img: null | string;
    normalGuide: null | boolean;
    doubleGuide: null | boolean;
    overlayGuide: null | boolean;
    insetGuide: null | boolean;
    subguide: null | boolean;
    subguideMountedOverTopRail: null | boolean;
    spaceLamellaMm: number;
    spaceEndRailMm: number;
    onEdge: boolean;
    between: boolean;
    defaultGuideHandleId: number | null;
    order?: number;
    shutterTypes: number[];
    child: null | Guide;
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    cornerBox?: boolean;
    spaceLamellaAxisMm?: number;
    noCalculationCorrectionInnerGuide?: boolean;
    guideBoxInsertionMm?: number;
}
